import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { ImageURLs } from '../../../utils/constants';

import './FormLogoHeader.scss';

const FormLogoHeader = () => (
  <Row className="logo no-gutters mx-0">
    <Col data-testid="logo-col" xs={3} md={6} lg={8} className="logo-image d-flex p-md-4 p-3">
      <Link to="/" className="w-100 h-100">
        <img
          data-testid="logo-img"
          src={ImageURLs.praktioMakeMistakes}
          alt="Praktio: Make Mistakes"
          className="img-fluid"
        />
      </Link>
    </Col>
  </Row>
);

export default FormLogoHeader;
